'use strict';

const khInitRuntime = window.khThemeRuntime || {};
const khInitMessages = khInitRuntime.messages || {};
const khInitMessage = (key, fallback) => khInitMessages[key] || fallback;

/**
 * Wait for the DOM to load before initializing core UI functions.
 */
document.addEventListener('DOMContentLoaded', () => {
    // Initialize navigation toggle functionality
    initTeejit_Nav();
    // Initialize loading circle while log in
    initTeejit_LoadingLogin();
    // Set up smooth scrolling for accordion headers
    initTeejit_scrollTo();
    // Set up accordion behavior (click and keyboard handling)
    initTeejit_accordion();
    // Set up label filtering based on checkboxes
    initTeejit_LabelFilter();
    // Initialize Slick slider (if enabled)
    //initTeejit_slick();
    // Initialize password toggle for showing/hiding text
    initTeejit_PasswordToggleShow();
    // Initialize password toggle for showing/hiding text on register password one
    initTeejit_PasswordToggleShowRegOne();
    // Initialize password toggle for showing/hiding text on register password two
    initTeejit_PasswordToggleShowRegTwo();
    // Initialize live validation for the registration password field
    initRegisterPasswordValidation();
    // Initialize the profile editing overlay functionality
    init_Teejit_TeejitEditProfilData();
});

/**
 * Initialize the navigation toggle.
 * Attaches a click event to the navigation toggle button to show/hide the navigation pane.
 */
const initTeejit_Nav = () => {
    jQuery(document).on("click", "#t-nav-toggle-left-menu", function () {
        jQuery("#t-nav").toggle();
        var toggleButton = jQuery(this);
        var iconSpan = toggleButton.find('.t-nav-head-element-icon');
        var isExpanded = toggleButton.attr('aria-expanded') === 'true';

        if (isExpanded) {
            // Sidebar schließen
            toggleButton.attr('aria-expanded', 'false');
            toggleButton.attr('aria-label', khInitMessage('openLeftSidebar', 'Open left sidebar'));
            iconSpan.text('left_panel_open');
        } else {
            // Sidebar öffnen
            toggleButton.attr('aria-expanded', 'true');
            toggleButton.attr('aria-label', khInitMessage('closeLeftSidebar', 'Close left sidebar'));
            iconSpan.text('left_panel_close');
        }
    });
    // Keyboard-Support hinzufügen
    jQuery(document).on("keydown", "#t-nav-toggle-left-menu", function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            jQuery(this).click();
        }
    });
};

/**
 * Initialize the loading circle while loging in.
 * Attaches a click event to the login submit button to show/hide the teejit loading logo.
 */
const initTeejit_LoadingLogin = () => {
    jQuery(document).on("click", "#teejit-login-submit", function (e) {
        const email = jQuery("#user_email").val().trim();
        const password = jQuery("#user_password").val().trim();

        if (email === "" || password === "") {
            e.preventDefault();
            return false;
        }

        //jQuery("#t-login-form-loading").attr('style', 'display: flex !important');
    });
};

/**
 * Initialize accordion functionality.
 * Adds click and keyboard event listeners to elements with the "accordion-buttons" class,
 * enabling toggling of corresponding content sections and keyboard navigation.
 */
const initTeejit_accordion = () => {
    const buttons = Array.from(document.querySelectorAll('.accordion-buttons'));
    buttons.forEach(button => {
        // On click: toggle the aria-expanded state and associated content visibility.
        button.addEventListener('click', () => {
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            const contentId = button.getAttribute('aria-controls');
            const content = document.getElementById(contentId);
            console.log(contentId);
            // Toggle expanded attribute and hide/show content accordingly
            button.setAttribute('aria-expanded', !isExpanded);
            content.hidden = isExpanded;
        });
        // On keydown: handle keyboard navigation using ArrowUp, ArrowDown, Home, and End keys.
        button.addEventListener('keydown', (e) => {
            // Use the cached buttons array for navigation, not a new query
            const index = buttons.indexOf(button);
            switch (e.key) {
                case 'ArrowUp':
                    e.preventDefault();
                    if (index > 0) {
                        buttons[index - 1].focus();
                    }
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    if (index < buttons.length - 1) {
                        buttons[index + 1].focus();
                    }
                    break;
                case 'Home':
                    e.preventDefault();
                    buttons[0].focus();
                    break;
                case 'End':
                    e.preventDefault();
                    buttons[buttons.length - 1].focus();
                    break;
            }
        });
    });
};

/**
 * Initialize smooth scrolling for accordion headers.
 * When a summary element with class "accordion-header" is clicked, the window scrolls smoothly to the
 * associated content element, offset by the header height.
 */
const initTeejit_scrollTo = () => {
    jQuery(document).on("click", "summary.accordion-header", function () {
        let accordionId = jQuery(this).attr('id').split('-');
        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 0;
        const target = document.getElementById(accordionId[1]);
        if (target) {
            window.scrollTo({
                top: target.offsetTop - headerHeight,
                behavior: 'smooth'
            });
        }
    });
};

/**
 * Initialize label filtering.
 * When a label in the filter section is clicked, this function toggles the display of related elements
 * based on the associated checkbox's state.
 */
const initTeejit_LabelFilter = () => {
    jQuery('.t-filter-main-element label').on('click', function () {
        // Obtain the checkbox associated with this label
        const checkbox = jQuery(this).siblings('input[type="checkbox"]');
        // Retrieve the checkbox name and split it to extract variable parts
        const checkboxName = checkbox.attr('name');
        const nameParts = checkboxName ? checkboxName.split('_') : [];
        if (nameParts.length === 4) {
            const variable = nameParts[2];
            const zahl = nameParts[3];
            // Select target elements that have the matching data attribute
            const targetElements = jQuery(`.t-button-directory[data-${variable}="${zahl}"]`);
            // Delay is set to ensure the checkbox state has updated before toggling display
            setTimeout(function () {
                if (checkbox.is(':checked')) {
                    targetElements.css('display', 'flex');
                } else {
                    targetElements.css('display', 'none');
                }
            }, 0);
        }
    });
};

/**
 * Initialize the profile data editing overlay.
 * When an element with the "edit" class is clicked, an overlay with a simple form is created for editing.
 */
const init_Teejit_TeejitEditProfilData = () => {
    jQuery(".edit").on("click", function () {
        // Get the closest parent row identifier
        const row = this.closest('.t-table-row');
        const id = row ? row.id : null;
        // Create an overlay to cover the current content
        var overlay = $('<div>').css({
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'grey',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        });
        // Define the container for the form with white background and padding
        var formContainer = $('<div>').css({
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '5px'
        });
        // Create a form element
        var form = $('<form>');
        // Add three text input fields to the form
        for (var i = 1; i <= 3; i++) {
            form.append($('<input>').attr({
                type: 'text',
                placeholder: khInitMessage('input', 'Input') + ' ' + i
            }).css({
                display: 'block',
                margin: '10px 0'
            }));
        }
        // Create a submit button
        var submitButton = $('<button>').attr('type', 'submit').text(khInitMessage('submit', 'Submit')).css({
            display: 'block',
            margin: '10px 0'
        });
        // Create a close button that removes the overlay on click
        var closeButton = $('<button>').text(khInitMessage('close', 'Close')).css({
            display: 'block',
            margin: '10px 0'
        });
        closeButton.on('click', function () {
            overlay.remove();
        });
        // Append the buttons to the form and the form to the container
        form.append(submitButton, closeButton);
        formContainer.append(form);
        // Append the form container to the overlay and insert the overlay into the page
        overlay.append(formContainer);
        $('#t-content-wrapper').append(overlay);
    });
};

const initRegisterPasswordValidation = () => {
    const forms = [
        {
            form: '#t-registerform',
            password: '#user_password_one',
            confirm: '#user_password_two',
            rules: '#register-password-rules',
            feedback: '#register-password-feedback',
            submit: '#teejit-register-submit',
        },
        {
            form: '#t-lostpassword-form',
            password: '#user_password_one',
            confirm: '#user_password_two',
            rules: '#lost-password-rules',
            feedback: '#lost-password-feedback',
            submit: '#teejit-login-submit',
        },
        {
            form: '#t-resetpassword-form',
            password: '#user_password_one',
            confirm: '#user_password_two',
            rules: '#reset-password-rules',
            feedback: '#reset-password-feedback',
            submit: '#teejit-reset-submit',
        },
    ];

    forms.forEach((config) => {
        const form = document.querySelector(config.form);
        const passwordField = document.querySelector(config.password);
        const confirmField = document.querySelector(config.confirm);
        const rulesContainer = document.querySelector(config.rules);
        const feedback = document.querySelector(config.feedback);
        const submitButton = document.querySelector(config.submit);

        if (!form || !passwordField || !confirmField || !rulesContainer || !submitButton) {
            return;
        }

        const allowedCharsPattern = /^[A-Za-z0-9#+*$&§!?_\-()\[\]=/@]+$/u;
        const specialCharsPattern = /[#\+\*\$&§!\?_\-\(\)\[\]=\/@]/u;
        const invalidMessage = rulesContainer.dataset.invalidMessage || 'Please meet all password requirements.';
        const mismatchMessage = rulesContainer.dataset.mismatchMessage || 'Passwords do not match.';
        const allowedCharsMessage = rulesContainer.dataset.allowedCharsMessage || 'Allowed special characters are only: #+*$&§!?_-()[]=/@';
        const unmetRuleMessages = {
            'letter-case': rulesContainer.dataset.ruleLetterCaseMessage || 'Uppercase and lowercase letters are required.',
            'number': rulesContainer.dataset.ruleNumberMessage || 'At least 1 number is required.',
            'special': rulesContainer.dataset.ruleSpecialMessage || 'At least 1 allowed special character is required.',
            'length': rulesContainer.dataset.ruleLengthMessage || 'At least 10 characters are required.',
        };

        const detailsList = feedback ? feedback.querySelector('[data-role="details"]') : null;
        const allowedCharsNote = rulesContainer.querySelector('[data-role="allowed-chars-note"]');
        const requiredFieldControls = Array.from(form.querySelectorAll('[data-required-field-error]'));
        let hasSubmitted = !feedback?.hidden;

        const getState = (password) => {
            const hasUppercase = /[A-Z]/.test(password);
            const hasLowercase = /[a-z]/.test(password);

            return {
                'letter-case': hasUppercase && hasLowercase,
                'number': /\d/.test(password),
                'special': specialCharsPattern.test(password),
                'length': password.length >= 10,
                allowedCharactersOnly: password.length > 0 && allowedCharsPattern.test(password),
            };
        };

        const updateRuleState = (ruleName, isValid, hasInput) => {
            const ruleElement = rulesContainer.querySelector(`[data-rule="${ruleName}"]`);

            if (!ruleElement) {
                return;
            }

            ruleElement.classList.toggle('is-valid', hasInput && isValid);
            ruleElement.classList.toggle('is-invalid', hasInput && !isValid);
            ruleElement.classList.toggle('is-pending', !hasInput);
        };

        const renderFeedback = (messages) => {
            if (!feedback || !detailsList) {
                return;
            }

            if (!messages.length) {
                feedback.hidden = true;
                detailsList.innerHTML = '';
                return;
            }

            detailsList.innerHTML = messages.map((message) => `<li>${message}</li>`).join('');
            feedback.hidden = false;
        };

        const collectValidationMessages = (passwordIsValid, confirmMatches, state) => {
            const messages = [];

            if (!passwordIsValid) {
                Object.entries(unmetRuleMessages).forEach(([ruleName, message]) => {
                    if (!state[ruleName]) {
                        messages.push(message);
                    }
                });

                if (passwordField.value !== '' && !state.allowedCharactersOnly) {
                    messages.push(allowedCharsMessage);
                }
            }

            if (!confirmMatches) {
                messages.push(mismatchMessage);
            }

            return messages;
        };

        const syncSubmitState = () => {
            submitButton.disabled = false;
            submitButton.setAttribute('aria-disabled', 'false');
        };

        const syncRequiredFieldError = (field, shouldShow) => {
            const errorId = field.dataset.requiredFieldError;
            const error = errorId ? document.getElementById(errorId) : null;
            const fieldIsEmpty = (field.type === 'checkbox' || field.type === 'radio')
                ? !field.checked
                : String(field.value || '').trim() === '';
            const isInvalid = Boolean(field.required && fieldIsEmpty);

            field.classList.toggle('is-invalid', shouldShow && isInvalid);
            field.setAttribute('aria-invalid', shouldShow && isInvalid ? 'true' : 'false');

            if (error) {
                error.hidden = !(shouldShow && isInvalid);
            }

            return isInvalid;
        };

        const syncRequiredFieldErrors = (shouldShow) => {
            let firstInvalidField = null;

            requiredFieldControls.forEach((field) => {
                const isInvalid = syncRequiredFieldError(field, shouldShow);
                if (isInvalid && !firstInvalidField) {
                    firstInvalidField = field;
                }
            });

            return firstInvalidField;
        };

        const syncValidation = () => {
            const password = passwordField.value;
            const confirmPassword = confirmField.value;
            const hasPasswordInput = password.length > 0;
            const state = getState(password);

            Object.entries(state).forEach(([ruleName, isValid]) => {
                if (ruleName === 'allowedCharactersOnly') {
                    return;
                }

                updateRuleState(ruleName, isValid, hasPasswordInput);
            });

            if (allowedCharsNote) {
                allowedCharsNote.hidden = !hasPasswordInput || state.allowedCharactersOnly;
            }

            const passwordIsValid = hasPasswordInput &&
                state['letter-case'] &&
                state['number'] &&
                state['special'] &&
                state['length'] &&
                state.allowedCharactersOnly;

            const confirmMatches = confirmPassword === '' || password === confirmPassword;

            passwordField.setCustomValidity(password === '' || passwordIsValid ? '' : invalidMessage);
            confirmField.setCustomValidity(confirmMatches ? '' : mismatchMessage);

            if (hasSubmitted) {
                const messages = collectValidationMessages(passwordIsValid, confirmMatches, state);
                renderFeedback(messages);
                syncRequiredFieldErrors(true);
            }

            syncSubmitState();

            return { passwordIsValid, confirmMatches, state };
        };

        passwordField.addEventListener('input', syncValidation);
        passwordField.addEventListener('blur', syncValidation);
        confirmField.addEventListener('input', syncValidation);
        confirmField.addEventListener('blur', syncValidation);
        form.addEventListener('input', syncSubmitState);
        form.addEventListener('change', syncSubmitState);
        requiredFieldControls.forEach((field) => {
            field.addEventListener('input', () => syncRequiredFieldError(field, hasSubmitted));
            field.addEventListener('change', () => syncRequiredFieldError(field, hasSubmitted));
        });

        submitButton.addEventListener('click', (event) => {
            hasSubmitted = true;
            const { passwordIsValid, confirmMatches, state } = syncValidation();
            const messages = collectValidationMessages(passwordIsValid, confirmMatches, state);
            const firstInvalidRequiredField = syncRequiredFieldErrors(true);

            if (!messages.length && !firstInvalidRequiredField) {
                renderFeedback([]);
                return;
            }

            event.preventDefault();
            renderFeedback(messages);

            if (!passwordIsValid) {
                passwordField.focus();
                return;
            }

            if (firstInvalidRequiredField) {
                firstInvalidRequiredField.focus();
                return;
            }

            confirmField.focus();
        });

        form.addEventListener('submit', (event) => {
            const { passwordIsValid, confirmMatches, state } = syncValidation();
            const messages = collectValidationMessages(passwordIsValid, confirmMatches, state);
            const firstInvalidRequiredField = syncRequiredFieldErrors(true);

            if (!messages.length && !firstInvalidRequiredField) {
                renderFeedback([]);
                return;
            }

            event.preventDefault();
            hasSubmitted = true;
            renderFeedback(messages);

            if (!passwordIsValid) {
                passwordField.focus();
                return;
            }

            if (firstInvalidRequiredField) {
                firstInvalidRequiredField.focus();
                return;
            }

            confirmField.focus();
        });

        syncValidation();
        syncSubmitState();
    });
};

/**
 * Initialize the password visibility toggle.
 * Changes the password input field type between "password" and "text" and updates the toggle icon accordingly.
 */
const initTeejit_PasswordToggleShow = () => {
    const $toggle = jQuery('#togglePassword');
    const $passwordField = jQuery('#user_password');
    const $toggleSpan = $toggle.find('span');
    $toggle.click(function () {
        const fieldType = $passwordField.attr('type');
        if (fieldType === 'text') {
            // Hide the password by changing type to "password" and update icon text
            $passwordField.attr('type', 'password');
            $toggleSpan.text('visibility');
        } else {
            // Show the password by changing type to "text" and update icon text
            $passwordField.attr('type', 'text');
            $toggleSpan.text('visibility_off');
        }
    });
};
const initTeejit_PasswordToggleShowRegOne = () => {
    const $toggle = jQuery('#togglePasswordOne');
    const $passwordField = jQuery('#user_password_one');
    const $toggleSpan = $toggle.find('span');
    $toggle.click(function () {
        const fieldType = $passwordField.attr('type');
        if (fieldType === 'text') {
            // Hide the password by changing type to "password" and update icon text
            $passwordField.attr('type', 'password');
            $toggleSpan.text('visibility');
        } else {
            // Show the password by changing type to "text" and update icon text
            $passwordField.attr('type', 'text');
            $toggleSpan.text('visibility_off');
        }
    });
};
const initTeejit_PasswordToggleShowRegTwo = () => {
    const $toggle = jQuery('#togglePasswordTwo');
    const $passwordField = jQuery('#user_password_two');
    const $toggleSpan = $toggle.find('span');
    $toggle.click(function () {
        const fieldType = $passwordField.attr('type');
        if (fieldType === 'text') {
            // Hide the password by changing type to "password" and update icon text
            $passwordField.attr('type', 'password');
            $toggleSpan.text('visibility');
        } else {
            // Show the password by changing type to "text" and update icon text
            $passwordField.attr('type', 'text');
            $toggleSpan.text('visibility_off');
        }
    });
};
/**
 * Initialize the Slick slider.
 * The initialization code for the slider has been commented out.
 * Uncomment the relevant block to enable the slider functionality.
 */
function initTeejit_slick() {
    jQuery(function () {
        jQuery('.slick-off').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3
        });
        jQuery('.t-row-single-off').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true
        });
    });
}

/**
 * Executes a function when the DOM is ready.
 * If the document is already loaded, the function runs immediately;
 * otherwise, it is executed once the document is ready.
 *
 * @param {Function} fn - The function to execute when the DOM is ready.
 */
function executeWhenReady(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        jQuery(document).ready(fn);
    }
}

function executeWhenVisible(selector, fn, rootMargin = '220px') {
    executeWhenReady(() => {
        const target = document.querySelector(selector);
        if (!target || !('IntersectionObserver' in window)) {
            fn();
            return;
        }

        let executed = false;
        const run = () => {
            if (executed) {
                return;
            }
            executed = true;
            fn();
        };

        const observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
                observer.disconnect();
                run();
            }
        }, { rootMargin });

        observer.observe(target);
    });
}

function initTeamContentFilter() {
    const filter = document.querySelector('[data-team-content-filter]');
    if (!filter) {
        return;
    }

    const targetSelector = filter.getAttribute('data-target') || '.content-detail-teams';
    const container = document.querySelector(targetSelector);
    const searchInput = filter.querySelector('[data-team-filter-search]');
    const tagSelect = filter.querySelector('[data-team-filter-tag]');
    const chipsElement = filter.querySelector('[data-team-filter-chips]');
    const resetButton = filter.querySelector('[data-team-filter-reset]');
    const countElement = filter.querySelector('[data-team-filter-count]');
    const emptyElement = document.querySelector('[data-team-filter-empty]');

    if (!container || !searchInput || !tagSelect || !chipsElement || !resetButton || !countElement) {
        return;
    }

    const filterText = window.khThemeRuntime?.teamContentFilter || {};
    const filterLocale = (window.khThemeRuntime?.locale || document.documentElement.lang || '')
        .replace('_', '-')
        .trim() || undefined;
    const translate = (key, fallback) => filterText[key] || fallback;
    const formatCount = (visible, total) => {
        const template = translate('count', '%1$s of %2$s contents');
        return template
            .replace('%1$s', visible)
            .replace('%2$s', total);
    };
    const formatRemoveFilter = (label) => translate('removeFilter', 'Remove filter %s').replace('%s', label);
    const normalize = (value) => String(value || '').trim().toLowerCase();
    const selectedTags = new Map();
    const typeLabels = {
        articles: translate('typeArticle', 'Article'),
        article: translate('typeArticle', 'Article'),
        event: translate('typeEvent', 'Event'),
        content_group: translate('typeCourse', 'Course'),
        course: translate('typeCourse', 'Course'),
        test: translate('typeTest', 'Test'),
        method: translate('typeMethod', 'Method'),
        certificate: translate('typeCertificate', 'Certificate')
    };

    const getCards = () => Array.from(container.querySelectorAll('.t-button-directory'));
    const getCardTypeLabel = (card) => {
        const kind = normalize(card.getAttribute('data-content-kind') || card.getAttribute('data-load-contenttype'));
        return typeLabels[kind] || translate('typeContent', 'Content');
    };
    const getCardTags = (card) => {
        const tags = Array.from(card.querySelectorAll('.t-tag-wrapper .t-tag'))
            .map((tag) => tag.textContent.trim())
            .filter(Boolean);

        tags.push(getCardTypeLabel(card));
        return Array.from(new Set(tags));
    };
    const updateTagOptions = (cards) => {
        const options = new Map();

        cards.forEach((card) => {
            getCardTags(card).forEach((label) => {
                const value = normalize(label);
                if (value) {
                    options.set(value, label);
                }
            });
        });

        Array.from(selectedTags.keys()).forEach((value) => {
            if (!options.has(value)) {
                selectedTags.delete(value);
            }
        });

        tagSelect.innerHTML = '';
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = translate('allTopics', 'Alle Themen und Typen');
        tagSelect.appendChild(defaultOption);
        Array.from(options.entries())
            .sort((a, b) => {
                try {
                    return a[1].localeCompare(b[1], filterLocale);
                } catch (e) {
                    return a[1].localeCompare(b[1]);
                }
            })
            .forEach(([value, label]) => {
                if (selectedTags.has(value)) {
                    return;
                }

                const option = document.createElement('option');
                option.value = value;
                option.textContent = label;
                tagSelect.appendChild(option);
            });

        tagSelect.value = '';
    };
    const renderChips = () => {
        chipsElement.innerHTML = '';
        chipsElement.hidden = selectedTags.size === 0;

        selectedTags.forEach((label, value) => {
            const chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'kh-team-content-filter__chip';
            chip.setAttribute('data-team-filter-chip', value);
            chip.setAttribute('aria-label', formatRemoveFilter(label));
            chip.innerHTML = `<span>${label}</span><span aria-hidden="true">×</span>`;
            chipsElement.appendChild(chip);
        });
    };
    const placeFilterInContentSection = () => {
        const sectionHead = container.querySelector('.active-team-content .t-kh-home-row-h');
        if (!sectionHead || sectionHead.nextElementSibling === filter) {
            return;
        }

        sectionHead.after(filter);
        if (emptyElement) {
            filter.after(emptyElement);
        }
    };
    const applyFilter = () => {
        const cards = getCards();
        const searchTerm = normalize(searchInput.value);
        const activeTags = Array.from(selectedTags.keys());
        let visibleCount = 0;

        cards.forEach((card) => {
            const tags = getCardTags(card).map(normalize);
            const haystack = normalize(card.textContent);
            const matchesSearch = !searchTerm || haystack.includes(searchTerm);
            const matchesTag = activeTags.length === 0 || activeTags.every((tag) => tags.includes(tag));
            const isVisible = matchesSearch && matchesTag;

            card.hidden = !isVisible;
            card.classList.toggle('kh-team-filter-hidden', !isVisible);

            if (isVisible) {
                visibleCount++;
            }
        });

        countElement.textContent = cards.length
            ? formatCount(visibleCount, cards.length)
            : translate('loading', 'Loading content...');

        if (emptyElement) {
            emptyElement.hidden = !cards.length || visibleCount > 0;
        }
    };
    const syncAndApply = () => {
        const cards = getCards();
        placeFilterInContentSection();
        updateTagOptions(cards);
        renderChips();
        applyFilter();
    };

    searchInput.addEventListener('input', applyFilter);
    tagSelect.addEventListener('change', () => {
        const value = tagSelect.value;
        const option = tagSelect.selectedOptions[0];

        if (value && option && !selectedTags.has(value)) {
            selectedTags.set(value, option.textContent.trim());
        }

        tagSelect.value = '';
        updateTagOptions(getCards());
        renderChips();
        applyFilter();
    });
    chipsElement.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-team-filter-chip]');
        if (!chip) {
            return;
        }

        selectedTags.delete(chip.getAttribute('data-team-filter-chip'));
        updateTagOptions(getCards());
        renderChips();
        applyFilter();
    });
    resetButton.addEventListener('click', () => {
        searchInput.value = '';
        tagSelect.value = '';
        selectedTags.clear();
        updateTagOptions(getCards());
        renderChips();
        applyFilter();
        searchInput.focus();
    });

    if ('MutationObserver' in window) {
        let scheduled = false;
        const observer = new MutationObserver(() => {
            if (scheduled) {
                return;
            }
            scheduled = true;
            window.requestAnimationFrame(() => {
                scheduled = false;
                syncAndApply();
            });
        });

        observer.observe(container, { childList: true });
    }

    syncAndApply();
}

executeWhenReady(initTeamContentFilter);

function initCertificateContentFilter() {
    const filter = document.querySelector('[data-certificate-content-filter]');
    if (!filter) {
        return;
    }

    const targetSelector = filter.getAttribute('data-target') || '.t-row-single.certificate';
    const container = document.querySelector(targetSelector);
    const searchInput = filter.querySelector('[data-certificate-filter-search]');
    const channelSelect = filter.querySelector('[data-certificate-filter-channel]');
    const statusSelect = filter.querySelector('[data-certificate-filter-status]');
    const chipsElement = filter.querySelector('[data-certificate-filter-chips]');
    const resetButton = filter.querySelector('[data-certificate-filter-reset]');
    const countElement = filter.querySelector('[data-certificate-filter-count]');
    const emptyElement = document.querySelector('[data-certificate-filter-empty]');

    if (!container || !searchInput || !channelSelect || !statusSelect || !chipsElement || !resetButton || !countElement) {
        return;
    }

    const filterText = window.khThemeRuntime?.certificateContentFilter || {};
    const filterLocale = (window.khThemeRuntime?.locale || document.documentElement.lang || '')
        .replace('_', '-')
        .trim() || undefined;
    const translate = (key, fallback) => filterText[key] || fallback;
    const normalize = (value) => String(value || '').trim().toLowerCase();
    const formatCount = (visible, total) => {
        const template = translate('count', '%1$s of %2$s certificates');
        return template
            .replace('%1$s', visible)
            .replace('%2$s', total);
    };
    const formatRemoveFilter = (label) => translate('removeFilter', 'Remove filter %s').replace('%s', label);
    const selectedChannels = new Map();

    const getCards = () => Array.from(container.querySelectorAll('.t-button-directory'))
        .filter((card) => card.style.display !== 'none');
    const matchesStatus = (card, status) => {
        switch (status) {
            case 'due':
                return card.dataset.due === '1';
            case 'overdue':
                return card.dataset.overDue === '1';
            case 'due-soon':
                return card.dataset.dueSoon === '1';
            case 'valid-until':
                return card.dataset.validUntil === '1' || card.classList.contains('certificate-valid');
            case 'finished':
                return card.dataset.finished === '1';
            case 'all':
            default:
                return true;
        }
    };
    const getChannelLabel = (card) => {
        const channelName = card.getAttribute('data-certificate-channel-name');
        if (channelName) {
            return channelName;
        }

        const channelId = card.getAttribute('data-certificate-channel-id');
        return channelId ? translate('channelFallback', 'Channel %s').replace('%s', channelId) : '';
    };
    const updateChannelOptions = (cards) => {
        const options = new Map();

        cards.forEach((card) => {
            const channelId = card.getAttribute('data-certificate-channel-id');
            const channelLabel = getChannelLabel(card);
            if (channelId && channelLabel) {
                options.set(channelId, channelLabel);
            }
        });

        Array.from(selectedChannels.keys()).forEach((value) => {
            if (!options.has(value)) {
                selectedChannels.delete(value);
            }
        });

        channelSelect.innerHTML = '';
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = translate('allChannels', 'All channels');
        channelSelect.appendChild(defaultOption);
        Array.from(options.entries())
            .sort((a, b) => {
                try {
                    return a[1].localeCompare(b[1], filterLocale);
                } catch (e) {
                    return a[1].localeCompare(b[1]);
                }
            })
            .forEach(([value, label]) => {
                if (selectedChannels.has(value)) {
                    return;
                }

                const option = document.createElement('option');
                option.value = value;
                option.textContent = label;
                channelSelect.appendChild(option);
            });

        channelSelect.value = '';
    };
    const renderChips = () => {
        chipsElement.innerHTML = '';
        chipsElement.hidden = selectedChannels.size === 0;

        selectedChannels.forEach((label, value) => {
            const chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'kh-team-content-filter__chip';
            chip.setAttribute('data-certificate-filter-chip', value);
            chip.setAttribute('aria-label', formatRemoveFilter(label));
            chip.innerHTML = `<span>${label}</span><span aria-hidden="true">×</span>`;
            chipsElement.appendChild(chip);
        });
    };
    const applyFilter = () => {
        const cards = getCards();
        const searchTerm = normalize(searchInput.value);
        const activeStatus = statusSelect.value || 'all';
        const activeChannels = Array.from(selectedChannels.keys());
        let visibleCount = 0;

        cards.forEach((card) => {
            const channelId = card.getAttribute('data-certificate-channel-id') || '';
            const haystack = normalize(card.textContent + ' ' + getChannelLabel(card));
            const matchesSearch = !searchTerm || haystack.includes(searchTerm);
            const matchesStatusFilter = matchesStatus(card, activeStatus);
            const matchesChannel = activeChannels.length === 0 || activeChannels.includes(channelId);
            const isVisible = matchesSearch && matchesStatusFilter && matchesChannel;

            card.hidden = !isVisible;
            card.classList.toggle('kh-team-filter-hidden', !isVisible);

            if (isVisible) {
                visibleCount++;
            }
        });

        countElement.textContent = formatCount(visibleCount, cards.length);

        if (emptyElement) {
            emptyElement.hidden = !cards.length || visibleCount > 0;
        }
    };
    const syncAndApply = () => {
        const cards = getCards();
        updateChannelOptions(cards);
        renderChips();
        applyFilter();
    };

    searchInput.addEventListener('input', applyFilter);
    statusSelect.addEventListener('change', applyFilter);
    channelSelect.addEventListener('change', () => {
        const value = channelSelect.value;
        const option = channelSelect.selectedOptions[0];

        if (value && option && !selectedChannels.has(value)) {
            selectedChannels.set(value, option.textContent.trim());
        }

        channelSelect.value = '';
        updateChannelOptions(getCards());
        renderChips();
        applyFilter();
    });
    chipsElement.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-certificate-filter-chip]');
        if (!chip) {
            return;
        }

        selectedChannels.delete(chip.getAttribute('data-certificate-filter-chip'));
        updateChannelOptions(getCards());
        renderChips();
        applyFilter();
    });
    resetButton.addEventListener('click', () => {
        searchInput.value = '';
        channelSelect.value = '';
        statusSelect.value = 'all';
        selectedChannels.clear();
        updateChannelOptions(getCards());
        renderChips();
        applyFilter();
        searchInput.focus();
    });

    syncAndApply();
}

executeWhenReady(initCertificateContentFilter);

function getKhRestBaseUrl() {
    return String(window.khThemeRuntime?.restBaseUrl || '/wp-json/knowhub/v1').replace(/\/+$/, '');
}

function normalizeHtmlResponse(data) {
    if (typeof data === 'string') {
        return data;
    }
    if (data && typeof data.html === 'string') {
        return data.html;
    }
    if (data && typeof data.data === 'string') {
        return data.data;
    }
    return '';
}

function requestKhRestHtml(method, path, params, access_token, success, error) {
    const httpMethod = String(method || 'GET').toUpperCase();
    const token = String(access_token || window.khThemeRuntime?.userAccessToken || '');
    const payload = {
        ...(params || {}),
    };
    if (token) {
        payload.user_access_token = token;
    }

    const ajaxOptions = {
        type: httpMethod,
        url: getKhRestBaseUrl() + '/' + String(path || '').replace(/^\/+/, ''),
        dataType: 'json',
        headers: token ? {Authorization: 'Bearer ' + token} : {},
        success: function (data) {
            success(normalizeHtmlResponse(data));
        },
        error: error || notifyTeamContentsLoadError,
    };

    if (httpMethod === 'GET') {
        ajaxOptions.data = payload;
    } else {
        ajaxOptions.data = JSON.stringify(payload);
        ajaxOptions.contentType = 'application/json';
    }

    jQuery.ajax(ajaxOptions);
}

function requestTeamContentsHtmlByRest(team_id, access_token, limit, success, error) {
    const params = new URLSearchParams();
    if (access_token) {
        params.set('user_access_token', access_token);
    }
    if (limit !== null && limit !== undefined && limit !== '') {
        params.set('limit', limit);
    }

    const query = params.toString();
    jQuery.ajax({
        type: 'GET',
        url: getKhRestBaseUrl() + '/load-team-contents/' + encodeURIComponent(team_id) + (query ? '?' + query : ''),
        dataType: 'json',
        headers: access_token ? { Authorization: 'Bearer ' + access_token } : {},
        success: function (data) {
            success(normalizeHtmlResponse(data));
        },
        error: error
    });
}

function notifyTeamContentsLoadError() {
    const message = window.khThemeRuntime?.teamContentFilter?.loadError || 'Content could not be loaded. Please try again later.';
    if (window.AWN) {
        new window.AWN({
            labels: {
                alert: 'Error'
            }
        }).alert(message, { durations: { global: 5000 } });
        return;
    }
    console.error(message);
}

/* =====================================================
   Exported AJAX Functions
   Each function performs an AJAX call to load dynamic content.
   The inner function doAjax is executed once the DOM is ready.
   The functions are also attached to the global window object.
   ===================================================== */

/**
 * Retrieves limited team contents via AJAX.
 *
 * @param {string} access_token - The access token for authentication.
 */
export function getTeam_ContentsLimited(access_token) {
    function doAjax() {
        requestKhRestHtml('POST', 'load-team-contents', {}, access_token, function (data) {
                jQuery('#teams-load-spinner').fadeOut();
                if (data?.length > 10) {
                    jQuery('div.t-kh-home-flag-navigation').after(data);
                }
            }, notifyTeamContentsLoadError);
    }
    executeWhenVisible('#teams-load-spinner', doAjax);
}
window.getTeam_ContentsLimited = getTeam_ContentsLimited;

/**
 * Retrieves team contents by team ID (limited) via AJAX.
 *
 * @param {number|string} team_id - The ID of the team.
 * @param {string} access_token - The access token for authentication.
 */
export function getTeam_ContentsLimitedByTeamID(team_id, access_token) {
    function doAjax() {
        const render = function (data) {
            jQuery('#teams-load-spinner-by-teams-id').fadeOut();
            if (data?.length > 10) {
                jQuery('div.teams-content-by-teams-id').html(data);
            }
        };

        requestTeamContentsHtmlByRest(team_id, access_token, null, render, notifyTeamContentsLoadError);
    }
    executeWhenVisible('#teams-load-spinner-by-teams-id', doAjax);
}
window.getTeam_ContentsLimitedByTeamID = getTeam_ContentsLimitedByTeamID;

/**
 * Retrieves team contents by team ID with optional limit via AJAX.
 *
 * @param {number|string} team_id - The team ID.
 * @param {string} access_token - The access token for authentication.
 * @param {number|null} [limit=null] - Optional limit on number of items.
 * @param {string} [spinner_id='teams-load-spinner-by-teams-id'] - The ID of the spinner element.
 * @param {string} [content_id='div.teams-content-by-teams-id'] - The selector for the content container.
 */
export function getTeam_ContentsByTeamID(team_id, access_token, limit = null, spinner_id = 'teams-load-spinner-by-teams-id', content_id = 'div.teams-content-by-teams-id') {
    function doAjax() {
        const render = function (data) {
            console.log('Successful - #' + spinner_id + ' - ' + content_id);
            jQuery('#' + spinner_id).fadeOut();
            if (data?.length > 10) {
                jQuery(content_id).html(data);
            }
        };

        requestTeamContentsHtmlByRest(team_id, access_token, limit, render, notifyTeamContentsLoadError);
    }
    executeWhenVisible('#' + spinner_id, doAjax);
}
window.getTeam_ContentsByTeamID = getTeam_ContentsByTeamID;

/**
 * Retrieves team slug content via AJAX.
 *
 * @param {string} access_token - The access token for authentication.
 */
export function getTeam_SlugContent(access_token) {
    function doAjax() {
        requestKhRestHtml('GET', 'load-team-slug-contents', {}, access_token, function (data) {
                jQuery('#teamsslug-load-spinner').fadeOut();
                if (data?.length > 10) {
                    jQuery('#t-kh-home-actual-training-serie').before(data);
                }
            }, notifyTeamContentsLoadError);
    }
    executeWhenVisible('#teamsslug-load-spinner', doAjax);
}
window.getTeam_SlugContent = getTeam_SlugContent;

/**
 * Retrieves team slug content by team ID via AJAX.
 *
 * @param {string} access_token - The access token.
 * @param {number|string} team_id - The team ID.
 */
export function getTeam_SlugContentByTeamId(access_token, team_id) {
    function doAjax() {
        requestKhRestHtml('GET', 'load-team-slug-contents/' + encodeURIComponent(team_id), {}, access_token, function (data) {
                jQuery('#teams-slug-content-load-spinner-by-teams-id').fadeOut();
                if (data?.length > 10) {
                    jQuery('div.teams-slug-content').before(data);
                }
            }, notifyTeamContentsLoadError);
    }
    executeWhenVisible('#teams-slug-content-load-spinner-by-teams-id', doAjax);
}
window.getTeam_SlugContentByTeamId = getTeam_SlugContentByTeamId;

/**
 * Retrieves the latest team news via AJAX.
 *
 * @param {string} access_token - The access token.
 * @param {number} limit - Maximum number of news items to retrieve.
 */
export function getTeam_GetLatestNews(access_token, limit) {
    function doAjax() {
        requestKhRestHtml('GET', 'theme/latest-news', {limit: limit}, access_token, function (data) {
                if (data?.length > 10) {
                    jQuery('div.latest-teams-news').html(data);
                }
            }, notifyTeamContentsLoadError);
    }
    executeWhenVisible('div.latest-teams-news', doAjax, '120px');
}
window.getTeam_GetLatestNews = getTeam_GetLatestNews;

/**
 * Retrieves content by tag ID via AJAX.
 *
 * @param {string} access_token - The access token.
 * @param {number|string} tag_id - The tag identifier.
 */
export function getContent_ByTagId(access_token, tag_id) {
    function doAjax() {
        requestKhRestHtml('GET', 'theme/tags/' + encodeURIComponent(tag_id) + '/contents', {}, access_token, function (data) {
                if (data?.length > 10) {
                    jQuery('section.content-by-tag-id-section').html(data);
                }
            }, notifyTeamContentsLoadError);
    }
    executeWhenReady(doAjax);
}
window.getContent_ByTagId = getContent_ByTagId;

/**
 * Retrieves content by tag ID with additional filters via AJAX.
 *
 * @param {string} access_token - The access token.
 * @param {number|string} tag_id - The tag identifier.
 * @param {object} filters - Filter parameters to narrow down the content.
 */
export function getContent_ByTagIdWithFilter(access_token, tag_id, filters) {
    function doAjax() {
        requestKhRestHtml('GET', 'theme/tags/' + encodeURIComponent(tag_id) + '/contents', {filters: filters}, access_token, function (data) {
                if (data?.length > 10) {
                    jQuery('section.content-by-tag-id-section').html(data);
                }
            }, notifyTeamContentsLoadError);
    }
    executeWhenReady(doAjax);
}
window.getContent_ByTagIdWithFilter = getContent_ByTagIdWithFilter;

/**
 * Retrieves user-marked content via AJAX.
 *
 * @param {string} access_token - The access token.
 */
export function getUser_MarkedContent(access_token) {
    function doAjax() {
        requestKhRestHtml('GET', 'theme/user/marked-content', {}, access_token, function (data) {
                jQuery('#user-load-spinner-marked-content').fadeOut();
                if (data?.length > 10) {
                    jQuery('div.user-marked-content').html(data);
                }
            }, notifyTeamContentsLoadError);
    }
    executeWhenReady(doAjax);
}
window.getUser_MarkedContent = getUser_MarkedContent;

/**
 * Retrieves user-marked content via AJAX.
 *
 * @param {string} access_token - The access token.
 */
export function getUser_UpcomingEventsContent(limit) {
    function doAjax() {
        requestKhRestHtml('GET', 'theme/user/events/upcoming', {limit: limit}, null, function (data) {
                jQuery('#user-load-spinner-events-content').fadeOut();
                if (data?.length > 10) {
                    jQuery('div.user-events-content').html(data);
                }
            }, notifyTeamContentsLoadError);
    }
    executeWhenReady(doAjax);
}
window.getUser_UpcomingEventsContent = getUser_UpcomingEventsContent;


/**
 * Retrieves user-marked content via AJAX.
 *
 * @param {string} access_token - The access token.
 */
export function getUser_RecentEventsContent(limit) {
    function doAjax() {
        requestKhRestHtml('GET', 'theme/user/events/recent', {limit: limit}, null, function (data) {
                jQuery('#user-load-spinner-recent-events-content').fadeOut();
                if (data?.length > 10) {
                    jQuery('div.user-recent-events-content').html(data);
                }
            }, notifyTeamContentsLoadError);
    }
    executeWhenReady(doAjax);
}
window.getUser_RecentEventsContent = getUser_RecentEventsContent;

export function getUser_TeamEventsContent(limit) {
    function doAjax() {
        requestKhRestHtml('GET', 'theme/user/events/teams', {limit: limit}, null, function (data) {
                jQuery('#user-load-spinner-teams-events-content').fadeOut();
                if (data?.length > 10) {
                    jQuery('div.user-teams-events-content').html(data);
                }
            }, notifyTeamContentsLoadError);
    }
    executeWhenReady(doAjax);
}
window.getUser_TeamEventsContent = getUser_TeamEventsContent;

export function getUser_InformationEventsContent(event_id, content_wrapper_id) {
    function doAjax() {
        requestKhRestHtml('GET', 'theme/events/' + encodeURIComponent(event_id) + '/html', {content_wrapper_id: content_wrapper_id}, null, function (data) {
                jQuery('#user-load-spinner-information-events-content').fadeOut();
                if (data?.length > 10) {
                    jQuery('div.user-information-events-content').html(data);
                }
            }, notifyTeamContentsLoadError);
    }
    executeWhenReady(doAjax);
}
window.getUser_InformationEventsContent = getUser_InformationEventsContent;

/**
 * Retrieves detailed content by its ID via AJAX.
 *
 * @param {number|string} content_id - The content identifier.
 */
export function getContent_ContentById(content_id) {
    const escapeHtml = (value) => String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

    const renderContentLoadError = (message = null) => {
        const fallbackMessage = window.khThemeRuntime?.contentDetail?.loadTitle
            || window.khThemeRuntime?.teamContentFilter?.loadError
            || 'Content could not be loaded.';
        const safeMessage = String(fallbackMessage);
        const detailMessage = window.khThemeRuntime?.contentDetail?.loadError
            || 'The content exists, but could not be retrieved right now. Please try again later.';
        jQuery('#content-detail-load-spinner').fadeOut();
        jQuery('#t-content-wrapper').html(
            '<div class="t-notice event-danger">' +
            '<h3>' + escapeHtml(safeMessage) + '</h3>' +
            '<p>' + escapeHtml(detailMessage) + '</p>' +
            '</div>'
        );
    };

    const renderHtml = (html) => {
        jQuery('#content-detail-load-spinner').fadeOut();
        if (typeof html === 'string' && html.trim().length > 10) {
            jQuery('#t-content-wrapper').html(html);
            return true;
        }
        return false;
    };

    function doAjax() {
        const runtime = window.khThemeRuntime || {};
        const restBaseUrl = String(runtime.restBaseUrl || '').replace(/\/+$/, '');
        const accessToken = String(runtime.userAccessToken || '');

        if (!restBaseUrl || !accessToken) {
            renderContentLoadError();
            return;
        }

        jQuery.ajax({
            type: 'GET',
            url: restBaseUrl + '/content/' + encodeURIComponent(content_id) + '/html',
            dataType: 'json',
            headers: {
                Authorization: 'Bearer ' + accessToken
            },
            success: function (response) {
                if (response?.success && renderHtml(response.html)) {
                    return;
                }
                renderContentLoadError();
            },
            error: function () {
                renderContentLoadError();
            }
        });
    }
    executeWhenReady(doAjax);
}
window.getContent_ContentById = getContent_ContentById;
